/* eslint-disable react-hooks/exhaustive-deps */
import { useAlert, useRedirectToRootPage } from '@orientaction/hooks';
import { isAdminVerify } from '@orientaction/utils';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getBeneficiaryResourcesBackPath } from '../../../Tests/shared/adminResultNav';

type BookParams = {
  id?: string;
  index?: string;
};

type UseLegacyEbookReaderOptions = {
  getMyValueBook: (id: string) => Promise<any>;
  hydrateValue: (value: any) => void;
  setId: (id: number) => void;
};

export const useLegacyEbookReader = ({
  getMyValueBook,
  hydrateValue,
  setId,
}: UseLegacyEbookReaderOptions) => {
  const alert = useAlert();
  const { goToRootPage } = useRedirectToRootPage();
  const { id, index } = useParams<BookParams>();

  const [loading, setLoading] = useState(false);
  const [readOnly, setReadOnly] = useState(true);
  const [userId, setUserId] = useState(0);

  useEffect(() => {
    const loadBook = async () => {
      if (!id) {
        return;
      }

      setLoading(true);

      try {
        const response = await getMyValueBook(id);

        hydrateValue(response.data.value);
        setReadOnly(response.data.readOnly);
        setUserId(response.data.value.users_permissions_user.id);
      } catch (err: any) {
        if (
          err?.response?.data?.error?.name === 'PolicyError' &&
          err?.response?.data?.error?.status === 403
        ) {
          alert.openSimpleAlert('Cette page ne vous est pas accessible.');
          goToRootPage();
          return;
        }

        alert.openSimpleAlert();
      } finally {
        setLoading(false);
      }
    };

    loadBook();

    if (id) {
      setId(Number(id));
    }
  }, [id]);

  return {
    loading,
    readOnly,
    index: index ? Number(index) : undefined,
    toBack: isAdminVerify() ? getBeneficiaryResourcesBackPath(userId) : '/mes-ressources',
  };
};
